let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d61VX")).then(() => parcelRequire('3Ahl5'));